module.exports = __webpack_public_path__ + "static/media/people-carry.b80b0ba3.svg";